import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './HeatmapLegendButton.scss';

export default function HeatmapLegendButton({
  toggleLegend = () => {
    Logger.error('something went wrong with toggleLegend prop');
  },
}) {
  return (
    <ButtonWithIcon
      data-e2e="legend"
      type="borderless"
      size="small"
      linkIconSize="s"
      sprite="InformationOutlineCircle"
      layout="vertical"
      tabIndex="0"
      onClick={() => {
        toggleLegend();
      }}
      className="result-toolbar-heatmap-legend-button e2e-legend"
      aria-label="Toggle Heatmap Legend">
      Legend
    </ButtonWithIcon>
  );
}

HeatmapLegendButton.propTypes = {
  toggleLegend: PropTypes.func,
};
